import { render, staticRenderFns } from "./honorImg.vue?vue&type=template&id=48994726&scoped=true"
import script from "./honorImg.vue?vue&type=script&lang=js"
export * from "./honorImg.vue?vue&type=script&lang=js"
import style0 from "./honorImg.vue?vue&type=style&index=0&id=48994726&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48994726",
  null
  
)

export default component.exports